import React from "react";

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const StarworksLogo = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
    <defs>
      <linearGradient id="logo-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#c4b5fd" />
        <stop offset="60%" stopColor="#8b5cf6" />
        <stop offset="100%" stopColor="#6d28d9" />
      </linearGradient>
      <linearGradient id="logo-grad-2" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#f472b6" />
        <stop offset="100%" stopColor="#a78bfa" />
      </linearGradient>
    </defs>
    <path
      d="M16 2 L19 12.5 L29.5 13 L21.5 19 L24 29.5 L16 23.5 L8 29.5 L10.5 19 L2.5 13 L13 12.5 Z"
      fill="url(#logo-grad)"
      stroke="url(#logo-grad-2)"
      strokeWidth="1"
      strokeLinejoin="round"
    />
    <path
      d="M16 7 L17.5 13 L23 13.5 L19 17 L20.5 22.5 L16 19 L11.5 22.5 L13 17 L9 13.5 L14.5 13 Z"
      fill="rgba(255,255,255,0.18)"
    />
  </svg>
);

export const HomeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" {...stroke}>
    <path d="M3 11 L12 3 L21 11" />
    <path d="M5 10 V20 a1 1 0 0 0 1 1 H10 V14 H14 V21 H18 a1 1 0 0 0 1 -1 V10" />
  </svg>
);

export const TrophyIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" {...stroke}>
    <path d="M7 4 H17 V10 a5 5 0 0 1 -10 0 Z" />
    <path d="M7 6 H4 a2 2 0 0 0 -2 2 v1 a3 3 0 0 0 3 3 H7" />
    <path d="M17 6 H20 a2 2 0 0 1 2 2 v1 a3 3 0 0 1 -3 3 H17" />
    <path d="M9 20 H15" />
    <path d="M12 15 V20" />
  </svg>
);

export const GiftIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" {...stroke}>
    <rect x="3" y="9" width="18" height="5" rx="1" />
    <path d="M5 14 V20 a1 1 0 0 0 1 1 H18 a1 1 0 0 0 1 -1 V14" />
    <path d="M12 9 V21" />
    <path d="M12 9 C9 9 7 7 8 5 C9 3.5 11.5 4 12 6.5 C12.5 4 15 3.5 16 5 C17 7 15 9 12 9 Z" />
  </svg>
);

export const TargetIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" {...stroke}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="1.5" fill="currentColor" />
  </svg>
);

export const HelpIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" {...stroke}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9 a2.5 2.5 0 0 1 5 0 c0 1.5 -2.5 1.8 -2.5 3.5" />
    <circle cx="12" cy="17" r="0.6" fill="currentColor" />
  </svg>
);

export const LanguagesIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" {...stroke}>
    <path d="M4 19.5 V5 a1 1 0 0 1 1 -1 H11 V19.5 a1.5 1.5 0 0 0 -1.5 -1.5 H5 a1 1 0 0 0 -1 1.5 Z" />
    <path d="M20 19.5 V5 a1 1 0 0 0 -1 -1 H13 V19.5 a1.5 1.5 0 0 1 1.5 -1.5 H19 a1 1 0 0 1 1 1.5 Z" />
  </svg>
);

export const PixelsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" {...stroke}>
    <rect x="3.5" y="3.5" width="5" height="5" rx="0.8" />
    <rect x="9.5" y="3.5" width="5" height="5" rx="0.8" />
    <rect x="15.5" y="3.5" width="5" height="5" rx="0.8" />
    <rect x="3.5" y="9.5" width="5" height="5" rx="0.8" />
    <rect x="9.5" y="9.5" width="5" height="5" rx="0.8" fill="currentColor" />
    <rect x="15.5" y="9.5" width="5" height="5" rx="0.8" />
    <rect x="3.5" y="15.5" width="5" height="5" rx="0.8" />
    <rect x="9.5" y="15.5" width="5" height="5" rx="0.8" />
    <rect x="15.5" y="15.5" width="5" height="5" rx="0.8" />
  </svg>
);

export const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" {...stroke}>
    <circle cx="11" cy="11" r="7" />
    <path d="M16.5 16.5 L21 21" />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" {...stroke}>
    <path d="M6 9 L12 15 L18 9" />
  </svg>
);

export const ChevronRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" {...stroke}>
    <path d="M9 6 L15 12 L9 18" />
  </svg>
);

export const ArrowRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" {...stroke}>
    <path d="M5 12 H19" />
    <path d="M13 6 L19 12 L13 18" />
  </svg>
);

export const FlameIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
    <defs>
      <linearGradient id="flame-grad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#fbbf24" />
        <stop offset="60%" stopColor="#f97316" />
        <stop offset="100%" stopColor="#dc2626" />
      </linearGradient>
    </defs>
    <path
      d="M12 2 C13 6 17 7 17 12 C17 16 14.5 19 12 19 C9.5 19 7 16 7 12 C7 9 9 8 9.5 6 C10 8 11 9 12 9 C12 7 11 5 12 2 Z"
      fill="url(#flame-grad)"
    />
    <path
      d="M12 11 C12.5 13 14 14 14 16 C14 17.5 13 18.5 12 18.5 C11 18.5 10 17.5 10 16 C10 14.5 11 14 11.5 12.5 C11.7 13.4 12 13.5 12 11 Z"
      fill="#fde68a"
      opacity="0.9"
    />
  </svg>
);

export const GamesPlayedIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
    <defs>
      <linearGradient id="trophy-grad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#fbbf24" />
        <stop offset="100%" stopColor="#d97706" />
      </linearGradient>
    </defs>
    <path
      d="M7 4 H17 V10 a5 5 0 0 1 -10 0 Z"
      fill="url(#trophy-grad)"
      stroke="#92400e"
      strokeWidth="0.6"
    />
    <path
      d="M7 6 H4.5 a1.5 1.5 0 0 0 -1.5 1.5 v0.5 a3 3 0 0 0 3 3 H7"
      fill="none"
      stroke="#fbbf24"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M17 6 H19.5 a1.5 1.5 0 0 1 1.5 1.5 v0.5 a3 3 0 0 1 -3 3 H17"
      fill="none"
      stroke="#fbbf24"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <rect x="9.5" y="14.5" width="5" height="3" rx="0.5" fill="#92400e" />
    <rect x="8" y="17.5" width="8" height="2" rx="0.6" fill="#78350f" />
  </svg>
);

export const AvatarIcon = () => (
  <svg width="32" height="32" viewBox="0 0 40 40" aria-hidden="true">
    <defs>
      <linearGradient id="avatar-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#a78bfa" />
        <stop offset="100%" stopColor="#6d28d9" />
      </linearGradient>
    </defs>
    <circle cx="20" cy="20" r="20" fill="url(#avatar-grad)" />
    <circle cx="20" cy="20" r="18" fill="rgba(15,10,40,0.55)" />
    {/* Helmet visor */}
    <path
      d="M10 17 a10 10 0 0 1 20 0 v8 a4 4 0 0 1 -4 4 H14 a4 4 0 0 1 -4 -4 Z"
      fill="#1f1740"
      stroke="#a78bfa"
      strokeWidth="1.2"
    />
    <path
      d="M12 18 a8 8 0 0 1 16 0 v5 H12 Z"
      fill="url(#avatar-grad)"
      opacity="0.85"
    />
    <ellipse cx="16" cy="20" rx="1.6" ry="2" fill="#fff" />
    <ellipse cx="24" cy="20" rx="1.6" ry="2" fill="#fff" />
    {/* Antenna */}
    <line x1="20" y1="6" x2="20" y2="3" stroke="#a78bfa" strokeWidth="1.4" strokeLinecap="round" />
    <circle cx="20" cy="2.5" r="1.2" fill="#f472b6" />
  </svg>
);

export const StarIcon = ({ size = 16, solid = false }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <defs>
      <linearGradient id={`star-grad-${size}`} x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#fde68a" />
        <stop offset="100%" stopColor="#f59e0b" />
      </linearGradient>
    </defs>
    <path
      d="M12 2 L14.6 8.6 L21.5 9.2 L16.3 13.7 L18 20.5 L12 16.8 L6 20.5 L7.7 13.7 L2.5 9.2 L9.4 8.6 Z"
      fill={solid ? `url(#star-grad-${size})` : "currentColor"}
      stroke={solid ? "rgba(120,53,15,0.4)" : "none"}
      strokeWidth="0.6"
      strokeLinejoin="round"
    />
  </svg>
);

export const StarIcon3D = ({ size = 100 }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" aria-hidden="true">
    <defs>
      <linearGradient id="star3d-light" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e9d5ff" />
        <stop offset="100%" stopColor="#a78bfa" />
      </linearGradient>
      <linearGradient id="star3d-mid" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#a78bfa" />
        <stop offset="100%" stopColor="#7c3aed" />
      </linearGradient>
      <linearGradient id="star3d-dark" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6d28d9" />
        <stop offset="100%" stopColor="#3b0a6e" />
      </linearGradient>
      <radialGradient id="star3d-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="rgba(167,139,250,0.55)" />
        <stop offset="60%" stopColor="rgba(139,92,246,0.18)" />
        <stop offset="100%" stopColor="rgba(0,0,0,0)" />
      </radialGradient>
    </defs>
    <circle cx="60" cy="60" r="58" fill="url(#star3d-glow)" />
    {/* Star outline (5-point) constructed as faceted polygons for a 3D look */}
    {/* center point */}
    {/* Right facet (light) */}
    <polygon
      points="60,12 67,46 60,52"
      fill="url(#star3d-light)"
    />
    <polygon
      points="60,12 60,52 53,46"
      fill="url(#star3d-mid)"
    />
    {/* Top right outer */}
    <polygon
      points="60,12 67,46 102,49 73,55"
      fill="url(#star3d-light)"
      opacity="0.95"
    />
    <polygon
      points="102,49 73,55 78,72"
      fill="url(#star3d-mid)"
    />
    <polygon
      points="102,49 78,72 96,90"
      fill="url(#star3d-dark)"
    />
    {/* Bottom right point */}
    <polygon
      points="78,72 96,90 73,79"
      fill="url(#star3d-mid)"
    />
    <polygon
      points="73,79 96,90 60,98"
      fill="url(#star3d-dark)"
    />
    {/* Bottom left point */}
    <polygon
      points="60,98 47,79 24,90"
      fill="url(#star3d-dark)"
    />
    <polygon
      points="47,79 24,90 42,72"
      fill="url(#star3d-mid)"
    />
    {/* Top left outer */}
    <polygon
      points="42,72 24,90 18,49"
      fill="url(#star3d-dark)"
    />
    <polygon
      points="18,49 42,72 47,55"
      fill="url(#star3d-mid)"
    />
    <polygon
      points="18,49 47,55 53,46"
      fill="url(#star3d-light)"
      opacity="0.95"
    />
    <polygon
      points="53,46 18,49 60,12"
      fill="url(#star3d-mid)"
    />
    {/* Specular highlight */}
    <polygon
      points="60,18 64,40 56,40"
      fill="rgba(255,255,255,0.55)"
    />
  </svg>
);

/* ---------- Game-card icons ---------- */

export const HangmanIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true">
    <defs>
      <linearGradient id="hang-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#c4b5fd" />
        <stop offset="100%" stopColor="#7c3aed" />
      </linearGradient>
    </defs>
    <path
      d="M10 42 L10 8 L34 8 L34 14"
      fill="none"
      stroke="url(#hang-grad)"
      strokeWidth="2.6"
      strokeLinecap="round"
    />
    <line
      x1="10"
      y1="42"
      x2="22"
      y2="42"
      stroke="url(#hang-grad)"
      strokeWidth="2.6"
      strokeLinecap="round"
    />
    <line
      x1="34"
      y1="14"
      x2="34"
      y2="22"
      stroke="url(#hang-grad)"
      strokeWidth="2.6"
      strokeLinecap="round"
    />
    {/* Star at the gallows hook */}
    <path
      d="M34 25 L36 30 L41 30.5 L37 33.5 L38.5 38 L34 35.5 L29.5 38 L31 33.5 L27 30.5 L32 30 Z"
      fill="url(#hang-grad)"
      opacity="0.9"
    />
  </svg>
);

export const FillerIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true">
    <defs>
      <linearGradient id="pencil-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#7dd3fc" />
        <stop offset="100%" stopColor="#2563eb" />
      </linearGradient>
    </defs>
    <g transform="rotate(-35 24 24)">
      <rect
        x="14"
        y="10"
        width="20"
        height="6"
        rx="1.5"
        fill="url(#pencil-grad)"
      />
      <rect x="14" y="10" width="6" height="6" rx="1.5" fill="#1d4ed8" />
      <rect
        x="14"
        y="16"
        width="20"
        height="20"
        fill="url(#pencil-grad)"
      />
      <polygon points="14,36 24,44 34,36" fill="#dbeafe" />
      <polygon points="20,36 24,40 28,36" fill="#1e293b" />
      <line
        x1="20"
        y1="13"
        x2="20"
        y2="36"
        stroke="rgba(255,255,255,0.25)"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export const DinoIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true">
    <defs>
      <linearGradient id="dino-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f9a8d4" />
        <stop offset="100%" stopColor="#be185d" />
      </linearGradient>
    </defs>
    {/* Pixelated dino silhouette */}
    <g fill="url(#dino-grad)">
      <rect x="26" y="8" width="14" height="4" />
      <rect x="26" y="12" width="16" height="4" />
      <rect x="22" y="16" width="20" height="4" />
      <rect x="22" y="20" width="20" height="4" />
      <rect x="14" y="24" width="24" height="4" />
      <rect x="14" y="28" width="20" height="4" />
      <rect x="14" y="32" width="14" height="4" />
      <rect x="14" y="36" width="6" height="4" />
      <rect x="22" y="36" width="6" height="4" />
    </g>
    <rect x="36" y="12" width="2" height="2" fill="#1f0a1a" />
  </svg>
);

export const MazeIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true">
    <defs>
      <linearGradient id="maze-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f472b6" />
        <stop offset="100%" stopColor="#9d174d" />
      </linearGradient>
    </defs>
    <rect
      x="6"
      y="6"
      width="36"
      height="36"
      rx="3"
      fill="none"
      stroke="url(#maze-grad)"
      strokeWidth="3"
    />
    <path
      d="M14 6 V20 H22 V14 H30 V28 H22 V42"
      fill="none"
      stroke="url(#maze-grad)"
      strokeWidth="3"
      strokeLinecap="square"
    />
    <path
      d="M30 36 H42"
      fill="none"
      stroke="url(#maze-grad)"
      strokeWidth="3"
      strokeLinecap="square"
    />
    <path
      d="M6 28 H14"
      fill="none"
      stroke="url(#maze-grad)"
      strokeWidth="3"
      strokeLinecap="square"
    />
  </svg>
);

export const OpsTicklesIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true">
    <defs>
      <linearGradient id="ops-grad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#cbd5e1" />
        <stop offset="50%" stopColor="#f8fafc" />
        <stop offset="100%" stopColor="#94a3b8" />
      </linearGradient>
      <linearGradient id="ops-fin" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#38bdf8" />
        <stop offset="100%" stopColor="#0369a1" />
      </linearGradient>
    </defs>
    <path d="M18 30 L10 42 L20 36 Z" fill="url(#ops-fin)" />
    <path d="M30 30 L38 42 L28 36 Z" fill="url(#ops-fin)" />
    <path
      d="M24 4 C31 12 33 24 31 36 L17 36 C15 24 17 12 24 4 Z"
      fill="url(#ops-grad)"
    />
    <circle cx="24" cy="20" r="5" fill="#0ea5e9" />
    <circle cx="24" cy="20" r="3" fill="#7dd3fc" />
    <path d="M24 4 L27 12 L21 12 Z" fill="#ef4444" />
    <path d="M20 36 Q24 46 28 36 Z" fill="#fb923c" opacity="0.9" />
  </svg>
);

export const MemoryIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true">
    <rect
      x="8"
      y="10"
      width="22"
      height="30"
      rx="3"
      fill="currentColor"
      opacity="0.45"
      transform="rotate(-8 19 25)"
    />
    <rect x="18" y="8" width="22" height="30" rx="3" fill="currentColor" />
  </svg>
);

export const SolitaireIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true">
    <rect x="8" y="12" width="20" height="28" rx="3" fill="currentColor" opacity="0.4" />
    <rect x="18" y="8" width="20" height="28" rx="3" fill="currentColor" />
    <circle cx="28" cy="22" r="5" fill="#c0392b" />
  </svg>
);

export const ChessIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true">
    <path
      fill="currentColor"
      d="M24 6c1.4 0 2.4 1.1 2.4 2.3 0 .7-.3 1.3-.8 1.7.8.5 1.4 1.3 1.6 2.2l2.3 1.2c.5-1 .9-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6 0 .5-.2 1-.6 1.3L30 18.2c.5.8.8 1.7.8 2.7 0 1.4-.6 2.6-1.5 3.5l1.4 8.2c.2 1.2-.7 2.4-2 2.4H19.3c-1.3 0-2.2-1.2-2-2.4l1.4-8.2c-.9-.9-1.5-2.1-1.5-3.5 0-1 .3-1.9.8-2.7l-2.1-3.5c-.4-.3-.6-.8-.6-1.3 0-.9.7-1.6 1.6-1.6.7 0 1.1.6 1.6 1.6l2.3-1.2c.2-.9.8-1.7 1.6-2.2-.5-.4-.8-1-.8-1.7C21.6 7.1 22.6 6 24 6zm0 3.2c-.5 0-.8.3-.8.7s.3.7.8.7.8-.3.8-.7-.3-.7-.8-.7zM18 40h12v2.5c0 .8-.7 1.5-1.5 1.5h-9c-.8 0-1.5-.7-1.5-1.5V40z"
    />
  </svg>
);

export const FlashcardsIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true">
    <rect
      className="flashcards-icon-back"
      x="10"
      y="8"
      width="28"
      height="36"
      rx="4"
      fill="#fde68a"
      opacity="0.35"
      transform="rotate(-8 24 26)"
    />
    <rect
      className="flashcards-icon-front"
      x="12"
      y="6"
      width="28"
      height="36"
      rx="4"
      fill="#fde68a"
    />
    <text
      className="flashcards-icon-text"
      x="26"
      y="28"
      textAnchor="middle"
      fill="#78350f"
      fontSize="14"
      fontWeight="700"
      fontFamily="system-ui, sans-serif"
    >
      3+4
    </text>
  </svg>
);

export const RocketIllustration = () => (
  <svg
    viewBox="0 0 520 520"
    width="100%"
    height="100%"
    aria-hidden="true"
    preserveAspectRatio="xMidYMid meet"
  >
    <defs>
      <radialGradient id="planet-grad" cx="35%" cy="40%" r="65%">
        <stop offset="0%" stopColor="#3b1d80" />
        <stop offset="60%" stopColor="#1b0e4a" />
        <stop offset="100%" stopColor="#0a0524" />
      </radialGradient>
      <radialGradient id="planet-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="rgba(167,139,250,0.45)" />
        <stop offset="70%" stopColor="rgba(139,92,246,0.05)" />
        <stop offset="100%" stopColor="rgba(0,0,0,0)" />
      </radialGradient>
      <linearGradient id="rocket-body" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#f5f3ff" />
        <stop offset="55%" stopColor="#c4b5fd" />
        <stop offset="100%" stopColor="#7c3aed" />
      </linearGradient>
      <linearGradient id="rocket-fin" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#a78bfa" />
        <stop offset="100%" stopColor="#4c1d95" />
      </linearGradient>
      <linearGradient id="rocket-window" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#67e8f9" />
        <stop offset="100%" stopColor="#1e40af" />
      </linearGradient>
      <linearGradient id="flame-grad-2" x1="50%" y1="0%" x2="50%" y2="100%">
        <stop offset="0%" stopColor="#fef9c3" />
        <stop offset="35%" stopColor="#fbbf24" />
        <stop offset="65%" stopColor="#a78bfa" />
        <stop offset="100%" stopColor="rgba(124,58,237,0)" />
      </linearGradient>
      <radialGradient id="flame-core" cx="50%" cy="30%" r="60%">
        <stop offset="0%" stopColor="#ffffff" />
        <stop offset="50%" stopColor="#fde68a" />
        <stop offset="100%" stopColor="rgba(255,255,255,0)" />
      </radialGradient>
    </defs>

    {/* Stars */}
    <g fill="#fff" opacity="0.85">
      <circle cx="60" cy="80" r="1.4" />
      <circle cx="120" cy="40" r="1.1" />
      <circle cx="200" cy="70" r="1.6" />
      <circle cx="300" cy="45" r="1.2" />
      <circle cx="400" cy="100" r="1.4" />
      <circle cx="470" cy="180" r="1.1" />
      <circle cx="40" cy="220" r="1.3" />
      <circle cx="90" cy="320" r="1.2" />
      <circle cx="430" cy="320" r="1.5" />
      <circle cx="490" cy="380" r="1.1" />
      <circle cx="170" cy="160" r="1.0" />
      <circle cx="380" cy="240" r="1.0" />
    </g>

    {/* Planet glow */}
    <circle cx="380" cy="370" r="240" fill="url(#planet-glow)" />

    {/* Planet */}
    <circle cx="400" cy="400" r="170" fill="url(#planet-grad)" />
    <ellipse
      cx="350"
      cy="350"
      rx="90"
      ry="20"
      fill="rgba(167,139,250,0.18)"
    />
    <ellipse
      cx="430"
      cy="430"
      rx="40"
      ry="8"
      fill="rgba(255,255,255,0.08)"
    />

    {/* Atmosphere highlight */}
    <path
      d="M270 360 a160 160 0 0 1 35 -110"
      fill="none"
      stroke="rgba(167,139,250,0.45)"
      strokeWidth="3"
      strokeLinecap="round"
    />

    {/* Rocket exhaust trail */}
    <g transform="translate(190 260) rotate(40)">
      <ellipse
        cx="0"
        cy="120"
        rx="38"
        ry="160"
        fill="url(#flame-grad-2)"
        opacity="0.92"
      />
      <ellipse
        cx="0"
        cy="80"
        rx="22"
        ry="90"
        fill="url(#flame-core)"
      />
      <ellipse
        cx="0"
        cy="50"
        rx="10"
        ry="35"
        fill="#ffffff"
        opacity="0.9"
      />
    </g>

    {/* Rocket */}
    <g transform="translate(260 220) rotate(40)">
      {/* Fins */}
      <path
        d="M-30 30 L-55 70 L-30 65 Z"
        fill="url(#rocket-fin)"
      />
      <path
        d="M30 30 L55 70 L30 65 Z"
        fill="url(#rocket-fin)"
      />
      {/* Body */}
      <path
        d="M-26 -90 C-26 -120 26 -120 26 -90 L26 60 C26 70 18 78 8 78 L-8 78 C-18 78 -26 70 -26 60 Z"
        fill="url(#rocket-body)"
        stroke="rgba(76,29,149,0.5)"
        strokeWidth="1.5"
      />
      {/* Body shading */}
      <path
        d="M14 -100 C18 -100 22 -90 22 -80 L22 60 C22 68 16 74 8 74 L8 -100 Z"
        fill="rgba(76,29,149,0.35)"
      />
      <path
        d="M-22 -85 C-22 -100 -16 -110 -10 -110 L-10 78 L-18 78 C-22 70 -22 60 -22 60 Z"
        fill="rgba(255,255,255,0.18)"
      />
      {/* Window */}
      <circle cx="0" cy="-30" r="14" fill="#0f172a" />
      <circle cx="0" cy="-30" r="11" fill="url(#rocket-window)" />
      <circle cx="-3" cy="-33" r="3" fill="rgba(255,255,255,0.7)" />
      {/* Stripe */}
      <rect x="-26" y="20" width="52" height="6" fill="#7c3aed" opacity="0.7" />
      {/* Nose tip highlight */}
      <path
        d="M-12 -110 C-6 -118 6 -118 12 -110"
        fill="none"
        stroke="rgba(255,255,255,0.8)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Booster nozzle */}
      <path
        d="M-20 70 L-26 90 L26 90 L20 70 Z"
        fill="#1e1b4b"
        stroke="#7c3aed"
        strokeWidth="1.2"
      />
    </g>
  </svg>
);
